import {
  Action,
  ChecksState,
  FunctionalitiesState,
  ModuleType
} from '@/modules/settings/roles/types/types.ts'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: FunctionalitiesState = {
  selectedId: undefined,
  selected: undefined,
  permissionsAssigned: {}
}

const functionalitiesSlice = createSlice({
  name: 'functionalities',
  initialState,
  reducers: {
    selectFunctionality(
      state,
      action: PayloadAction<
        | {
            id: string
            label: string
            items: ModuleType[]
          }
        | undefined
      >
    ) {
      state.selectedId = action.payload?.id
      state.selected = action.payload
    },
    setPermission(
      state,
      action: PayloadAction<{ key: string; assign: boolean }>
    ) {
      state.permissionsAssigned[action.payload.key] = action.payload.assign
    },
    setPermissionsAssigned(state, action: PayloadAction<ChecksState>) {
      state.permissionsAssigned = action.payload
    },
    setAllPermissions: (state, action: PayloadAction<boolean>) => {
      if (state.selected) {
        const keys: string[] = []
        state.selected?.items.map((item) => {
          item.actions.forEach((a: Action) => {
            keys.push(`${item.id}_${a.reference}`)
          })
        })
        Object.keys(state.permissionsAssigned).forEach((k) => {
          if (keys.includes(k)) {
            state.permissionsAssigned[k] = action.payload
          }
        })
      } else {
        Object.keys(state.permissionsAssigned).forEach((k) => {
          state.permissionsAssigned[k] = action.payload
        })
      }
    }
  }
})

export const functionalitiesActions = {
  ...functionalitiesSlice.actions
}
export const { reducer: functionalitiesReducer } = functionalitiesSlice
